import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import Sidenav from '../Sidenav/Sidenav'
import "./Layout.scss"
import { isTokenExpired } from '../../helpers/JwtUtils';

export default function Layout({ role }) {

    const navigate = useNavigate();
    useEffect(() => {
        const token = localStorage.getItem('medtoken');
        if (!token || isTokenExpired(token)) {
            navigate('/login');
        }
    }, [navigate]);

    return (
        <div className='flex justify-start items-center bg-[#f2f0f0]'>
            <div className="sidnav">
                <Sidenav role={role} />
            </div>
            <div className="all w-full overflow-hidden">
                <Outlet>
                </Outlet>
            </div>
        </div>
    )
}
